import { MultiplicityPatterns } from '..';
/**
 * look for a multiplet based on the pattern name or abbreviation.
 * @param name - pattern name or abbreviation.
 */
export function findMultiplet(name) {
    return MultiplicityPatterns.find((multiplet) => {
        const { label, value, names } = multiplet;
        return [label, value, ...names].includes(name);
    });
}
//# sourceMappingURL=findMultiplet.js.map